import { render, staticRenderFns } from "./KoioteValueLabel.vue?vue&type=template&id=90d3a8d6"
import script from "./KoioteValueLabel.vue?vue&type=script&lang=js"
export * from "./KoioteValueLabel.vue?vue&type=script&lang=js"
import style0 from "./KoioteValueLabel.vue?vue&type=style&index=0&id=90d3a8d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports